export default __webpack_public_path__ + "static/media/banner.3ffdd1b7.jpg";